import { useDispatch } from 'react-redux';
import {
    LocalStorage,
    useCall,
    useSelfViewContext,
    useTwilioUserMediaContext,
} from '../customer-call-sdk';
import { logout } from '../store/auth/actions';
import * as AuthAPI from '../services/auth.service';
import StorageContants from '../config/storage.constants';

export default function useLogout() {
    const dispatch = useDispatch();
    const call = useCall();
    const { destroyMedia } = useTwilioUserMediaContext();
    const { destroy: destroySelfView } = useSelfViewContext();

    return async (calledOnLogout: boolean = true) => {
        const deviceId = LocalStorage.get(StorageContants.UNIQUE_DEVICE_ID) || '';

        if (calledOnLogout) {
            await AuthAPI.logout({ deviceId });
        }

        destroySelfView();
        destroyMedia();
        call.destroy();
        dispatch(logout());
    };
}
